export default {
  key: 'angular',
  lang: 'typescript',
  generate: ({ baseUrl, websiteToken }) => `
// src/app/tola-widget.service.ts
import { Injectable } from '@angular/core';

const BASE_URL = '${baseUrl}';
const WEBSITE_TOKEN = '${websiteToken}';
const SCRIPT_ID = 'tola-sdk';

declare global {
  interface Window {
    tolaSDK: { run(options: { websiteToken: string; baseUrl: string }): void };
  }
}

@Injectable({ providedIn: 'root' })
export class TolaWidgetService {
  init(): void {
    // The SDK is a global singleton, so inject it only once.
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = BASE_URL + '/packs/js/sdk.js';
    script.async = true;
    script.onload = () => {
      window.tolaSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL });
    };
    document.head.appendChild(script);
  }
}

// Usage - in src/app/app.component.ts:
//   private tola = inject(TolaWidgetService);
//   ngOnInit(): void { this.tola.init(); }
`,
};
